import { InputSelect } from "@goodfill/ui-components";

export const FilterSimpleSelectBox = ({
  id,
  options,
  onChange,
  value,
  small,
}: {
  id?: string;
  options: string[];
  onChange: (value: string | null) => void;
  value: string | null;
  small?: boolean;
}) => {
  return (
    <InputSelect
      id={id}
      small={small}
      placeholder=""
      border="neutral"
      className="w-full"
      options={[{ label: "Any", value: "__any" }, ...options.map((option) => ({ label: option, value: option }))]}
      value={value === null ? "__any" : value}
      onChange={(value) => onChange(value === "__any" ? null : value)}
    />
  );
};
